import axios from "axios";
import { BASE_URL, TIMEOUT } from "./config";
import localCache from "@/utils/cache";
import { ElLoading, ElMessage } from "element-plus";
import "element-plus/theme-chalk/el-loading.css";
import "element-plus/theme-chalk/el-message.css";
import "element-plus/theme-chalk/el-message-box.css";
import "element-plus/theme-chalk/el-badge.css";

// 这里不能用useRouter，因为useRouter只能在setup中使用
import router from "@/router";

const DEFAULT_LOADING = true;

class Request {
  constructor(baseURL, timeout = 10000, showLoading) {
    axios.defaults.withCredentials = true;
    this.instance = axios.create({
      baseURL,
      timeout,
    });
    this.showLoading = showLoading ?? DEFAULT_LOADING;
    this.loading = null;

    this.instance.interceptors.request.use(
      (config) => {
        // 携带token的拦截
        const token = sessionStorage.getItem('token');
        if (token) {
          if (config.headers) {
            // config.headers.Authorization = `Bearer ${token}`; // jwt OAuth2.0方式要求
            // config.headers['Authentication'] = token; // 存疑
            config.headers.Authentication = token; // 存疑
          }
        }
        if (this.showLoading) {
          this.loading = ElLoading.service({
            lock: true,
            text: "正在请求数据...",
            background: "rgba(0, 0, 0, 0.5)",
          });
        }

        return config;
      },
      (err) => {
        return err;
      }
    );
    this.instance.interceptors.response.use(
      (res) => {
        this.loading?.close();
        // TODO 这里可能会有bug 当连续发送很多次请求时存在
        this.showLoading = DEFAULT_LOADING;
        // 301 表示token错误 或者 token过期 跳转到登录页
          if (res.data.code === 301) {
            console.log("token过期或错误");
            router.push("/login");
          }
        return res;
      },
      (err) => {
        this.loading?.close();
        ElMessage({
          showClose: true,
          message: "服务器异常，请联系管理员",
          grouping: true,
          type: "error"
        });
        return err;
      }
    );
  }

  request(config) {
    return new Promise((resolve, reject) => {
      // 根据单个请求设置的showLoading状态，改变全局loading的显示状态
      if (config.showLoading === false) {
        this.showLoading = config.showLoading;
      }
      this.instance
        .request(config)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  get(config) {
    return this.request({ ...config, method: "get" });
  }

  post(config) {
    return this.request({ ...config, method: "post" });
  }
  put(config) {
    return this.request({ ...config, method: "put" });
  }
  delete(config) {
    return this.request({ ...config, method: "delete" });
  }
}

export default new Request(BASE_URL, TIMEOUT);
